/**
 * Core renderer for converting AST nodes to React elements
 */

import { ReactNode } from 'react';
import type { AstNode, AstText, BlockAnnotationsLookup } from '../types';
import renderElement from './element';
/**
 * Renders AST nodes to React elements
 * Optional renderTextHook function allows custom text node rendering (for highlights)
 */
export function renderAst(
  ast: AstNode[],
  renderText?: (textNode: AstText) => ReactNode,
  annotationsByBlock?: BlockAnnotationsLookup,
): ReactNode[] {
  return ast.map((node) => {
    if (node.type === 0) {
      if (renderText) {
        return renderText(node);
      }
      return node.text;
    } else {
      return renderElement(node, renderText, annotationsByBlock);
    }
  });
}
